
import './style.scss';
import { Box, Typography } from '@mui/material';
import { IMuiIcon } from '../../interfaces/IMaterial';


interface IDataCardProps {
    variant?: 'default' | 'dashboard';
    Icon?: IMuiIcon;
    color?: string;
    className?: string;
    variantProps?: {
        default?: {
            category?: string;
            title: string;
            subtitle?: string;
        },
        dashboard?: {
            title: string;
            value: string;
            valueSulfix: string;
            percentage: number;
        }
    },
    onClick?: () => void;
}


const DataCard: React.FC<IDataCardProps> = ({
    variant = 'default',
    Icon = undefined,
    color = '',
    className = '',
    variantProps = undefined,
    onClick = () => { }
}) => {
    const style = {} as any;

    if (color) {
        style.color = `${color} !important`;
    }

    if (variant === 'dashboard') {
        const { title, value, valueSulfix, percentage } = variantProps?.dashboard ?? {
            title: '',
            value: 0,
            valueSulfix: '',
            percentage: 0
        };

        return (
            <Box 
                className={`datacard-default ${className} variant-${variant}`} 
                onClick={onClick} 
                {...style}
            >
                <Box className='datacard-title'>
                    {
                        Icon && <Icon />
                    }

                    <Typography variant='subtitle1'> {title} </Typography>
                </Box>

                <Box className='datacard-content'>
                    <Typography variant='subtitle2' className='datacard-value'> 
                        {value}

                        <Typography variant='subtitle2' className='fontweight-600 fontsize-12' paddingBottom={0.1}> 
                            {valueSulfix} 
                        </Typography>

                        <Typography variant='subtitle2' className='fontweight-600 fontsize-12 textalign-right flex-1' paddingBottom={0.1}> 
                            {percentage.toFixed(1)}
                            <Typography variant='caption' className='fontweight-600 fontsize-8' marginLeft={0.2}>%</Typography>
                        </Typography>
                    </Typography> 

                    <Box className='datacard-progressbar-container'>
                        <Box 
                            className='datacard-progressbar'
                            sx={{ 
                                backgroundColor: `${color} !important`, 
                                width: `${percentage}%` 
                            }} 
                        />
                    </Box>
                </Box>
            </Box>
        );
    }


    const { category, title, subtitle } = variantProps?.default ?? {
        category: undefined,
        title: '',
        subtitle: undefined,
    };

    return (
        <Box className={`datacard-default ${className} variant-${variant}`} onClick={onClick} {...style}>
            {
                category && <Typography variant='subtitle2' className='datacard-category'> 
                    {category} 
                </Typography> 
            }

            <Box className='datacard-title'>
                <Typography variant='subtitle1'> {title} </Typography>
            </Box>
            
            { 
                subtitle && <Typography variant='subtitle2' className='datacard-subtitle'> 
                    {subtitle} 
                </Typography> 
            }

            {
                Icon && <Icon className='datacard-icon' />
            }
        </Box>
    );
}

export default DataCard;